<template>
  <div id="app">
      <el-backtop target="" :bottom="100"></el-backtop>
    <el-container>
      <el-header style="padding:0;" class="div"><IndexHeader></IndexHeader></el-header>
      <el-main style="padding:0;">
        <router-view/>
        <IndexContent></IndexContent>
<!--        <Cooperation></Cooperation>-->
      </el-main>
      <el-footer style="padding:0;" class="div"><IndexFooter></IndexFooter></el-footer>
    </el-container>
  </div>
</template>

<script>
    import IndexHeader from "./components/IndexHeader";
    import IndexFooter from "./components/IndexFooter";
    import IndexContent from "./components/IndexContent";
    import Cooperation from "./components/Cooperation";
    export default {
        name: 'App',
      data(){
          return {
            hH: 0,
            mH: 0,
            fH: 0,
            screenHeight: document.body.clientHeight -220,
          }
      },
        components:{
            IndexHeader,IndexFooter,IndexContent,Cooperation
        },
      mounted () {
      },
      watch: {
      },
      methods:{
          /*getHeight(){
            console.log(document.documentElement.clientHeight*0.22);
            let y = document.documentElement.clientHeight;
            // this.hH = (y - 220)+'px';
            this.hH = (y * 0.08) + 'px';
            this.mH = (y * 0.7) + 'px';
            this.fH = (y * 0.22) + 'px';
          }*/
      },
      created() {
          // this.getHeight();
      }
    }
</script>

<style>
  /*html,body{ height:100%;}
   * html{ padding-top:100px;}*/
  body,.div{ margin:0; padding:0;}
  *{
    padding: 0;
    margin: 0;
  }
  #app {
    /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50; */
  }
  .el-header {
    /* width: 100%;
    background-color: #fff;
    color: #333;
    text-align: center;
    line-height: 60px;
    height: 60px; */
  }

 /* * html .el-header {
    background-color: #fff;
    color: #333;
    height: 60px;
    text-align: center;
    line-height: 60px;
    position:absolute;
    top:0;
    width:100%;
  }*/

  .el-main {
    color: #333;
    text-align: center;
    padding: 0;
    /*line-height: 160px;*/
  /*  position:absolute;
    width:100%;
    top:60px;
    bottom:0;
    overflow:auto;*/
  }

/*
  * html .el-main {
    color: #333;
    text-align: center;
    !*line-height: 160px;*!
    position:static;
    height:100%;
  }
*/
.el-carousel__container{
  height: 100% !important;
}

  .el-footer {
    color: #333;
    text-align: center;
    height: 160px !important;
  }

 /* * html .el-footer {
    color: #333;
    text-align: center;
    height: 160px !important;
    position: absolute;
    bottom: 0;
    width: 100%;
  }*/

  body > .el-container {
    margin-bottom: 40px;
  }
  .el-icon-caret-top{
    color: #ff6d1d;
  }
  .el-backtop{
    background-color: #ccc !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue